import React from "react";
import { useSelector } from "react-redux";
import DonutChart from "../../../../components/donut/donut";

const NewCustomers = () => {
  const { percentageOfNewVisits, newVisits, newVisitsPercentChange } = useSelector(
    (state) => state.attendance.activeClients
  );

  return (
    <DonutChart
      value={percentageOfNewVisits * 100}
      type="New"
      dollarValue={newVisits}
      growth={newVisitsPercentChange}
      toolTip="Percentage Change from previous month"
    />
  );
};
export default NewCustomers;
